export default {
  submitText: '提交',
  emptyBtn: false,
  labelWidth: 120,
  column: [],
  group: [
    {
        column: [
          {
            label: "项目名称",
            prop: "projectId",
            disabled:true,
            cascaderItem: ['userIds'],
            type: 'tree',
            dicUrl: '/api/v4ward/project/getProjectList',
            props: {label: 'name', value: 'id'},
            rules: [{
              required: true,
              message: "请选择项目名称",
              trigger: "change"
            }]
          },
          {
            label: "计划名称",
            prop: "name",
            search: true,
            maxlength: 30,
            showWordLimit: true,
            overHidden: true,
            rules: [{
              required: true,
              message: "请输入计划名称",
              trigger: "blur"
            }]
          },

          {
            label: "合格比例(%)",
            prop: "criterionScore",
            maxlength: 6,
            showWordLimit: true,
            rules: [
              { pattern: /^([0-9]{1,2}|100)$/, message: '请输入0-100的整数' },
              {
                required: true,
                message: "请输入合格比例(%)",
                trigger: "blur"
              }]

          },
          {
            label: "计算类型",
            prop: "calculateType",
            type: 'select',
            dataType: 'number',
            dicUrl: 'api/blade-system/dict/dictionary?code=calculate_type',
            props: { label: 'dictValue', value: 'dictKey' },
            rules: [{
              required: true,
              message: "请选择计算类型",
              trigger: "blur"
            }]
          },

          {
            label: "填报类型",
            prop: "informantType",
            type: 'radio',
            dataType: 'number',
            dicUrl: 'api/blade-system/dict/dictionary?code=informant_type',
            props: { label: 'dictValue', value: 'dictKey' },
            rules: [{
              required: true,
              message: "请选择填报类型",
              trigger: "blur"
            }]
          },
          {
            label: "填报对象",
            prop: "userIds",
            // type: "tree",
            multiple:true,
            display: false,
            formslot:true,
            span: 24,
            row: 4,
            // dicUrl: '/api/v4ward/user/project-user-list?projectId={{projectId}}',
            // props: { label: 'realName', value: 'id' },
            rules: [{
              required: true,
              message: "请输入负责人",
              trigger: "blur"
            }]
          },
          {
            label: "填报对象",
            prop: "deptIds",
            type: 'tree',
            multiple:true,
            span: 24,
            row: 4,
            display: false,
            dicUrl: 'api/v4ward/dept/treeByIds',
            props: { label: 'title', value: 'key' },
            rules: [{
              required: true,
              message: "请选择填报对象",
              trigger: "change"
            }]
          },

          {
            prop: 'test',
            label: '题目内容',
            formslot: true,
            labelslot: true,
            span: 24,
            row:true,
          },
        ]
    },
  ],
};
